import { LocationQueryValue } from 'vue-router'

export function getURLSearchParams(params: object): URLSearchParams {
  const urlParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (typeof value === 'undefined') continue
    urlParams.set(key, params[key])
  }
  return urlParams
}

export function getModifiedExtrasQueryParams(
  event: Record<string, number>,
  currentRouteQuery: Record<string, LocationQueryValue | LocationQueryValue[]>,
) {
  const query = { ...currentRouteQuery }
  Object.keys(query).forEach((key) => {
    if (
      key.match(/^form-\d{1,2}-extra$/) ||
      key.match(/^form-\d{1,2}-quantity$/)
    ) {
      delete query[key]
    }
  })
  // Sort extras by ID to ensure consistent ordering regardless of backend changes
  const sortedExtras = Object.keys(event).sort((a, b) => Number(a) - Number(b))
  for (const [index, extraId] of sortedExtras.entries()) {
    query[`form-${index}-extra`] = String(extraId)
    query[`form-${index}-quantity`] = String(event[extraId])
  }
  return new URLSearchParams(query as Record<string, string>)
}

export function modifyURLParams(query: URLSearchParams, currentPath: string) {
  history.replaceState(
    {},
    '',
    `${currentPath}?${decodeURIComponent(query.toString())}`,
  )
}
